import React from "react"

import BlogPostsSectionDesktop from "./BlogPostsSectionDesktop"
import BlogPostsSectionMobile from "./BlogPostsSectionMobile"

const BlogPostsSection = ({
  section,
  practice,
  theme,
  highlightedField,
  viewMode = "",
  deviceType = "desktop",
  viewingInBuilder = false
}) => {
  const commonProps = { section, practice, theme, highlightedField, viewingInBuilder }

  if (viewMode === "mobile") {
    return <BlogPostsSectionMobile {...commonProps} />
  }

  if (viewMode === "desktop") {
    return <BlogPostsSectionDesktop {...commonProps} />
  }

  if (deviceType === "mobile") {
    return <BlogPostsSectionMobile {...commonProps} />
  }

  return <BlogPostsSectionDesktop {...commonProps} />
}

export default BlogPostsSection
